<!-- @veltra/icons generated sha256:732fe7648ea8ede4 gen:8 source:src/svg/normal/warning.svg -->
<script setup lang="ts">
defineOptions({ name: 'Warning' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M8 1a7 7 0 1 1 0 14A7 7 0 0 1 8 1m0 13A6 6 0 1 0 8 2a6 6 0 0 0 0 12m.5-4.5V4h-1v5.5zm-1.106 1h1.2v1.2h-1.2z"
    />
  </svg>
</template>
